common.View.create('search::Bar', {

    currentIndex: -1,

    onDOMLoad() {
        this.initAjaxSearch();
    },

    initAjaxSearch() {
        // Set timer variable
        let timerDelay;

        // Find search field
        this.element.find('[name="query"]')
            .on('input', (event) => {
                this.currentIndex = -1;
                $('.search-item').removeClass('selected');

                // Save input in variable
                let input = $(event.currentTarget);

                // On more than 2 letters typed
                if ($(input).val().length > 2) {

                    // Clear any previously set timer before setting a fresh one
                    clearTimeout(timerDelay);

                    // Set timer and start search
                    timerDelay = setTimeout((event) => {

                        // Search on page
                        $.get(this.element.find('form').attr('action'), { query: $(input).val() }, (response) => {
                            // Show search results
                            this.element.find('.search-results').removeClass('hidden').html(response);

                            // On focus show again
                            $(input).focus(() => {
                                this.element.find('.search-results').removeClass('hidden').html(response);
                            });

                            // Check for click outside of results
                            $('body')
                                .on('click', (event) => {
                                    let container = this.element;

                                    // Check for click outside div
                                    if( !container.is(event.target) && container.has(event.target).length === 0 ) {
                                        this.element.find('.search-results').html('').addClass('hidden');
                                    }
                                });
                        });

                    }, 500);

                } else {
                    this.element.find('.search-results').html('').addClass('hidden');
                }

            })
            
            .on('keydown', (e) => {
                const results = this.element.find('.search-results .result-wrapper');

                // Prevent the cursor from jumping to the beginning of the field
                if([38.40].includes(e.which) ) {
                    e.preventDefault();
                }
                
                if (e.which === 40) { // Arrow Down
                    if (this.currentIndex === results.length - 1) {
                        // If it's the last result, deselect it
                        this.currentIndex = -1;
                    } else {
                        this.currentIndex++;
                    }
                } else if (e.which === 38) { // Arrow Up
                    if (this.currentIndex === 0) {
                        // If it's the first result or none is selected, deselect it
                        this.currentIndex = -1;
                    } else if(this.currentIndex === -1) {
                        // If none is selected, select the last result
                        this.currentIndex = results.length - 1;
                    } else {
                        this.currentIndex--;
                    }
                }
            
                // Clear previous selection
                results.removeClass('selected');
            
                // If a valid index is selected, add the selected class
                if (this.currentIndex >= 0 && this.currentIndex < results.length) {
                    results.eq(this.currentIndex).addClass('selected');
                }
            
                if (e.which === 13) { // Enter
                    if (this.currentIndex >= 0 && this.currentIndex < results.length) {
                        e.preventDefault();  // This will prevent the form submission
                        window.location.href = results.eq(this.currentIndex).attr('href');
                    }
                }
            });
    },

});
